import React from 'react';
import Container from '@material-ui/core/Container';
import { makeStyles, styled } from '@material-ui/core/styles';
import { Chip, colors } from '@material-ui/core';
import { Done } from '@material-ui/icons';
import { insh as inshst } from '../../../Context/InshSt';
import { balanceTypes } from './balanceCustRPT-services';
import { sto } from '../../../Context/InshData';

const useStyles = makeStyles((theme) => ({
    chip:{
    paddingLeft:'10px',
    paddingRight: '10px',
    marginLeft: '10px'
  },
}));

const ListItem = styled('li')(({theme}) =>({
  margin: theme.spacing(0.5),
}));

const SelectTypesFilter = (props)=>{
  const { rptParams, setRptParams, defaultAccount,}  = props;
  const classes = useStyles();

    return (
            <Container
                style={{
                  display:'flex',
                  justifyContent:'center',
                  flexWrap:'wrap',
                  listStyle:'none',
                  padding:'5px',
                  margin:'0px',
                }}
                component="ul" >
              {
                balanceTypes.map(x=>{

                  return <ListItem key={x.id}>
                    {
                      x.id ===rptParams.type.id ?
                      <Chip 
                        className={classes.chip} 
                        label={x.label} 
                        icon={<Done style={{color:'#fff'}}/>}
                        style={{backgroundColor: inshst.colors.cust,
                        color:'#ffffff'}}
                        clickable
                      />:
                      <Chip 
                        className={classes.chip} 
                        label={x.label} 
                        variant='outlined'
                        color={'default'}
                        disabled={sto.User_typei == 1?false:true}
                        onClick={()=>{setRptParams({...rptParams, 
                          type: x, account: defaultAccount })}}
                      />
                    }
                  </ListItem>
                })}
            </Container>
           
    )
}

export default SelectTypesFilter;